import React, { memo, forwardRef } from "react";
const SvgAlphabetZ = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.08 20.8c-.306 0-.553-.047-.74-.14a1.343 1.343 0 01-.42-.34 1.346 1.346 0 01-.2-.42 2.165 2.165 0 01-.04-.38c0-.187.04-.387.12-.6.093-.213.253-.44.48-.68l4.76-5.12H13c-.226 0-.413-.033-.56-.1a1.008 1.008 0 01-.32-.24.9.9 0 01-.16-.32 1.43 1.43 0 01-.04-.3c0-.08.014-.173.04-.28a.73.73 0 01.16-.3.887.887 0 01.32-.26c.147-.08.334-.12.56-.12h5.68c.294 0 .534.047.72.14.187.093.327.207.42.34a.94.94 0 01.2.42c.04.147.06.273.06.38 0 .187-.046.387-.14.6-.08.213-.233.44-.46.68l-4.78 5.08h4.54c.227 0 .407.04.54.12.147.067.26.153.34.26.08.093.133.2.16.32.027.107.04.2.04.28 0 .08-.013.18-.04.3a.902.902 0 01-.16.32 1.2 1.2 0 01-.34.26c-.133.067-.313.1-.54.1h-6.16z"
      />
    </svg>
  );
});
SvgAlphabetZ.displayName = "SvgAlphabetZ";
const MemoForwardRef = memo(SvgAlphabetZ);
export default MemoForwardRef;
